import React, { useRef, useCallback, useEffect } from 'react';
import { floor, map, size } from 'lodash';

import ChatAnswer from './components/chatAnswer';
import { DealAgentChat } from 'src/types/dealAgent';
import styles from './styles.module.scss';
import cx from 'classnames';
interface DealAgentChatProps {
    chats: DealAgentChat[];
    loadingChats?: boolean;
}

const Placeholder = () => {
    return (
    <div className={styles.placeholderContainer}>
            <div className={cx(styles.placeholder, styles.label)}>
                <span className={cx(styles.line, styles.block)} />
            </div>
            <div className={cx(styles.placeholder, styles.label)}>
                <span className={cx(styles.line, styles.block)} />
            </div>
            <div className={cx(styles.placeholder, styles.label)}>
                <span className={cx(styles.line, styles.block)} />
            </div>
            <div className={cx(styles.placeholder, styles.label)}>
                <span className={cx(styles.line, styles.block)} />
            </div>
            <div className={cx(styles.placeholder, styles.label)}>
                <span className={cx(styles.line, styles.block)} />
            </div>
            <div className={cx(styles.placeholder, styles.label)}>
                <span className={cx(styles.line, styles.block)} />
            </div>
    </div>)
}

const Chats: React.FC<DealAgentChatProps> = ({
    chats, loadingChats,
}) => {
    const chatContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => { // scroll to the bottom of the chat container (when the chats are updated)
        const container = chatContainerRef.current;
        if (!container || !size(chats)) return;
    
        const onHistoryLoad = chats.every((chat) => size(chat) === 4); // check if all the chats are initial history load

        if (onHistoryLoad) { // history restore flow
            container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth',
            });
            return;
        }

        const lastItem = chats[size(chats) - 1];

        if (lastItem?.creating) {  // while streaming / creating
            container.scrollTo({
                top: container.scrollHeight,
                behavior: "smooth",
            });
    
            return;
        }
    
        const lastElement = container.lastElementChild as HTMLElement; // after completed
        if (lastElement && !onHistoryLoad) { 
            container.scrollTo({
                top: lastElement.offsetTop - 100,
                behavior: "smooth",
            });
        }
    }, [chats]);


    return (
        <>
        { loadingChats ? <Placeholder/> : <>
            { size(chats) === 0 ? <span className={styles.empty}>
                 Ask anything about this deal...
            </span>
            :  <div ref={chatContainerRef} className={styles.chatContainer} > 
                { map(chats, (chat, index) => (
                    <React.Fragment key={chat.id}>
                        <ChatAnswer
                            index={index}
                            chat={chat}
                            skipTypewriting={false}
                            showDivider={size(chats) !== index+1}
                        />
                    </React.Fragment>
                ))} 
            </div> }
            </> }
        </>
    );
};

export default Chats;
